import { Component, OnInit, Input } from '@angular/core';
import { PendingPlatesService } from './pending-plates.service';
import { MessagesService } from '../messages/messages.service';
import { ErrorHandler } from '../utils/error-handler';
import { Container } from '../container-view/models/container';
import { EventEmitter, Output } from '@angular/core';
import { SelectableLab } from '../carrier/selectable-lab';

@Component({
  selector: 'app-pending-plates',
  templateUrl: './pending-plates.component.html'
})
export class PendingPlatesComponent implements OnInit {

  @Input() pendingReactionPlates: Container[];
  @Input() processedReactionPlates: Container[];

  responseContainers: Container[] = [];
  @Output() responseContainersEmitter = new EventEmitter<Container[]>();
  @Output() selectedPlateBarcodeEmitter = new EventEmitter<string>();
  @Output() pendingPlateIdEmitter = new EventEmitter<string>();
  @Output() newPlateEmitter = new EventEmitter<string>();
  @Output() plateStateEmitter = new EventEmitter<string>();

  errorHandler: ErrorHandler = new ErrorHandler;
  selectedRectionPlate: Container;
  plateBarcodeToEdit: string;
  selectedLab: SelectableLab;
  blocked = false;
  searchedBarcode: string;

  constructor(private pendingPlatesService: PendingPlatesService, private messagesService: MessagesService) {
    this.selectedLab = JSON.parse(localStorage.getItem('lab'));
  }

  ngOnInit() {

  }

  editReactionPlate() {
    if (this.selectedRectionPlate != undefined && this.selectedRectionPlate != null) {
      this.blocked = true;
      this.pendingPlatesService.getQuadrants(this.selectedRectionPlate._id).subscribe(
        results => {
          if (!results) {
            this.blocked = false;
            return;
          }
          this.blocked = false;
          this.responseContainers = results.data.containers;
          this.responseContainersEmitter.emit(this.responseContainers);
          this.plateStateEmitter.emit(results.data.state);

        },
        error => {
          this.blocked = false;
          let message = this.errorHandler.handleError(error);
          this.messagesService.addErrorMessage(message);

        }
      );
      this.selectedPlateBarcodeEmitter.emit(this.selectedRectionPlate.barcode);
      this.pendingPlateIdEmitter.emit(this.selectedRectionPlate._id);
      this.selectedRectionPlate = null;
      this.plateBarcodeToEdit = null;
    }
  }

  defineNewReactionPlate() {
    this.blocked = true;
    this.pendingPlatesService.getNewReactionPlate(this.selectedLab.lab).subscribe(
      results => {
        if (!results) {
          this.blocked = false;
          return;
        }
        this.blocked = false;
        this.selectedRectionPlate = results.data;
        this.editReactionPlate();
        this.messagesService.addSuccessMessage({ severity: 'success', summary: 'Added Reaction Plate', detail: 'Added Reaction Plate' });
        this.selectedRectionPlate = null;
      },
      error => {
        this.blocked = false;
        let message = this.errorHandler.handleError(error);
        this.messagesService.addErrorMessage(message);

      }
    );
  }
  
  searchOnEnter(barcode: string) {
    console.log('barcode searched is :' + barcode);
    this.blocked = true;
    this.pendingPlatesService.getQuadrantsfromSearchedBarcode(barcode).subscribe(
      results => {
        if (!results) {
          this.blocked = false;
          return;
        }
        this.responseContainers = results.data.containers;
        this.responseContainersEmitter.emit(this.responseContainers);
        this.plateStateEmitter.emit(results.data.state);
        this.selectedPlateBarcodeEmitter.emit(barcode);
        this.blocked = false;
      },
      error => {
        this.blocked = false;
        let message = this.errorHandler.handleError(error);
        this.messagesService.addErrorMessage(message);

      }
    );
    this.selectedRectionPlate = null;
    this.plateBarcodeToEdit = null;
  }
}
